import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import CampaignSourceParams from './CampaignSourceParams';

export type TagsInputValue = any[]

const mapStateToProps = (state, { t }) => {
  const campaignSourceParams: TagsInputValue = state.trackerSettings.app.settings
    .attributes.campaign_source_params || [];
  const globalCampaignSourceParams: TagsInputValue = (
    state.trackerSettings.global.settings
      .attributes.campaign_source_params || []
  )
    .map(
      element => ({
        value: element,
        disabled: true,
        tooltip: {
          content: t('apps.details.settings.globals.tooltip.content'),
        },
      }),
    );

  const globalAndAppTrackerSettings = [
    ...globalCampaignSourceParams,
    ...campaignSourceParams,
  ];

  return {
    globalAndAppTrackerSettings,
  };
};

export default withTranslation(['administration'])(connect(mapStateToProps, null)(CampaignSourceParams));
